import { useLanguage, LANGUAGES } from "../i18n";

export function LanguageSelector({ className = "" }) {
  const { lang, setLang } = useLanguage();
  
  return (
    <div className={`flex items-center gap-1 ${className}`} data-testid="language-selector">
      {LANGUAGES.map((l) => (
        <button
          key={l.code}
          onClick={() => setLang(l.code)}
          className={`px-2 py-1 text-xs font-bold uppercase tracking-wider transition-colors ${
            lang === l.code
              ? "text-[#FBBF24] bg-[#FBBF24]/10"
              : "text-gray-500 hover:text-white"
          }`}
          data-testid={`lang-${l.code}`}
          title={l.name}
        >
          {l.code}
        </button>
      ))}
    </div>
  );
}
